import {all, call, put, takeEvery} from 'redux-saga/effects'
import {
  AuthActionTypes,
  loginSuccess,
  loginError,
  updateSuccess,
  updateError,
  logoutSuccess,
  logoutError,
  changePasswordSuccess,
  changePasswordError,
  resetPasswordSuccess,
  resetPasswordError
} from '@actions/auth';
import {updateSuccess as updateCurrentUserInGrid} from '@actions/user';
import authApi from '@api/auth'
import {ReduxAction} from "@actions/index";

function* handleLogin({payload}: ReduxAction) {
  try {
    const {data} = yield call(authApi.login, payload);
    yield put(loginSuccess(data));
    localStorage.setItem("user", JSON.stringify(data));
    payload.onSuccessCallback();
  } catch (err) {
    yield put(loginError(err));
    payload.onErrorCallback && payload.onErrorCallback(err);
  }
}

function* handleUpdate({payload}: ReduxAction) {
  try {
    const {data} = yield call(authApi.update, payload);
    payload.onSuccessCallback && payload.onSuccessCallback(data);
    yield put(updateSuccess(data));
    // For updating current user info in users table:
    yield put(updateCurrentUserInGrid(data));
  } catch (err) {
    yield put(updateError(err));
    payload.onErrorCallback && payload.onErrorCallback(err);
  }
}

function* handleChangePassword({payload}: ReduxAction) {
  try {
    const {data} = yield call(authApi.changePassword, payload);
    payload.onSuccessCallback && payload.onSuccessCallback();
    yield put(changePasswordSuccess(data));
  } catch (err) {
    yield put(changePasswordError(err));
    payload.onErrorCallback && payload.onErrorCallback(err);
  }
}

function* handleResetPassword({payload}: ReduxAction) {
  try {
    const {data} = yield call(authApi.resetPassword, payload);
    payload.onSuccessCallback && payload.onSuccessCallback();
    yield put(resetPasswordSuccess(data));
  } catch (err) {
    yield put(resetPasswordError(err));
    payload.onErrorCallback && payload.onErrorCallback(err);
  }
}


function* handleLogout({payload}: ReduxAction) {
  try {
    const {data} = yield call(authApi.logout);
    payload.onSuccessCallback();
    yield put(logoutSuccess(data));
  } catch (err) {
    if (err.response.status == 401 || err.data.meta.error_number == 4010) {
      payload.onErrorCallback && payload.onErrorCallback(err);
      return false;
    }
    yield put(logoutError(err));
    payload.onErrorCallback && payload.onErrorCallback(err);
  }
}


// We can also use `fork()` here to split our saga into multiple watchers.
function* authSaga() {
  yield all([
    yield takeEvery(AuthActionTypes.LOGIN_REQUEST, handleLogin),
    yield takeEvery(AuthActionTypes.UPDATE_REQUEST, handleUpdate),
    yield takeEvery(AuthActionTypes.LOGOUT_REQUEST, handleLogout),
    yield takeEvery(AuthActionTypes.CHANGE_PASSWORD_REQUEST, handleChangePassword),
    yield takeEvery(AuthActionTypes.RESET_PASSWORD_REQUEST, handleResetPassword)
  ])
}

export default authSaga